import React from "react";
import ServicePageTemplate from "./ServicePageTemplate";
import { heroSlides } from "../../data/mockData";
import { usePricing } from "../../hooks/usePricing";

const laundrySlide = heroSlides.find((s) => s.id === "laundry");

const LaundryIroningPage = () => {
  const { laundry } = usePricing();
  const pageData = {
    pageTitle: "Laundry & Ironing Service Cardiff | Wash, Iron & Fold | NeatWave",
    quoteService: "Laundry & Ironing",
    metaDescription: "Professional laundry and ironing service in Cardiff. Washed, ironed and neatly folded by the NeatWave team. Reliable, professional and affordable. Get a free quote today.",

    heroTitle: "Laundry & Ironing Service in Cardiff",
    heroSubtitle: "From laundry pile to perfectly pressed. We wash, dry, iron and neatly fold your clothes and linen, so you get your evenings and weekends back.",
    heroImage: laundrySlide.image,

    serviceDescription: (
      <>
        <p className="mb-4">
          Busy week? Let NeatWave take the laundry off your hands. Our professional team washes, dries, irons and folds your everyday clothes, work shirts, bedding and towels with the same care and attention to detail we bring to every clean.
        </p>
        <p className="mb-4">
          We follow the care label on every item, separate colours and fabrics, and return everything neatly folded or on hangers, ready to put away. Ideal for busy families, professionals, landlords and Airbnb hosts across Cardiff.
        </p>
        <p className="mb-4">
          Add laundry and ironing to a regular clean, or book it on its own. Our team is DBS-checked and fully insured, and we treat your belongings with complete respect.
        </p>
      </>
    ),

    whatIncluded: [
      { title: "Wash & Dry", description: "Clothes sorted by colour and fabric, washed and dried following every care label" },
      { title: "Professional Ironing", description: "Shirts, trousers, dresses and linen pressed crisp and crease-free" },
      { title: "Neatly Folded", description: "Everything folded or hung, ready to go straight into your wardrobe" },
      { title: "Bedding & Towels", description: "Duvet covers, sheets, pillowcases and towels washed fresh and folded" },
      { title: "Airbnb Linen", description: "Turnover linen washed and pressed to a hotel-style finish for hosts" },
      { title: "Care & Respect", description: "Delicates handled gently, stains pointed out, nothing mixed up" },
    ],

    pricingInfo: {
      duration: "24-48 hours",
      price: `From £${Math.min(laundry.ironingItem, laundry.perKg)}`,
      note: "Use our quote calculator to get an instant estimate for your laundry, then request a free quote.",
    },

    priceList: [
      { item: "Wash, dry & fold (per kg)", price: `£${laundry.perKg}` },
      { item: "Ironing (per item)", price: `£${laundry.ironingItem}` },
      { item: "Duvet", price: `£${laundry.duvet}` },
      { item: "2-piece suit dry clean", price: `£${laundry.suitDryClean}` },
    ],

    faqs: [
      { q: "Do you collect and return my laundry?", a: "Yes. Just tell us your address and preferred times when you request a quote, and we will arrange a convenient collection and return across Cardiff." },
      { q: "Can you do ironing only?", a: "Absolutely. Many customers wash at home and leave the ironing to us. Ironing is priced per item." },
      { q: "How do you handle delicate items?", a: "We follow the care label on every item and wash delicates separately on gentle cycles. Anything marked dry-clean only is returned to you untouched." },
      { q: "Can I add laundry to my regular clean?", a: "Yes. Laundry and ironing can be added to any regular or Airbnb clean. Just mention it in the message box when you request a quote." },
    ],

    testimonial: {
      text: "The service was excellent, professional, and reliable, with great attention to detail. I would confidently recommend NeatWave Cleaning Services to anyone looking for quality cleaning services.",
      author: "Elvis Madu, Google review",
    },

    relatedServices: [
      { title: "Airbnb Cleaning", description: "Turnover cleans with fresh linen between guests", url: "/airbnb-cleaning-cardiff" },
      { title: "Regular Domestic Cleaning", description: "Weekly or fortnightly home cleaning", url: "/domestic-cleaning-cardiff" },
      { title: "Deep Cleaning", description: "A top-to-bottom refresh for your home", url: "/deep-cleaning-cardiff" },
    ],
  };

  return <ServicePageTemplate {...pageData} />;
};

export default LaundryIroningPage;
